"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ramda_1 = require("ramda");
const react_easy_emoji_1 = __importDefault(require("react-easy-emoji"));
const yaml_1 = __importDefault(require("yaml"));
const publicodes_1 = require("publicodes");
const { encodeRuleName } = publicodes_1.utils;
const getParents = (dottedName) => ramda_1.scan((acc, part) => [acc, part].filter(Boolean).join(' . '), '', dottedName.split(' . ')).filter(Boolean);
function getDependancies(engine, dottedName) {
    const rule = engine.evaluate(engine.getRule(dottedName));
    return publicodes_1.reduceAST((acc, node, fn) => {
        if (node.nodeKind === 'reference') {
            if (node.dottedName === rule.dottedName + ' . ' + node.name &&
                engine.getRule(node.dottedName).virtualRule) {
                return [...acc, ...getDependancies(engine, node.dottedName)];
            }
            else {
                return [...acc, ...getParents(node.dottedName)];
            }
        }
        if (node.nodeKind === 'variations' && typeof node.rawNode === 'string') {
            // We don't take replacement into account
            const originNode = node.explanation.slice(-1)[0].consequence;
            return [...acc, ...fn(originNode)];
        }
    }, [], rule.explanation.valeur);
}
function RuleSource({ engine, dottedName }) {
    const dependancies = [
        ...getDependancies(engine, dottedName),
        ...getParents(dottedName),
    ];
    const rule = engine.evaluate(engine.getRule(dottedName));
    // When we import a rule in the Publicodes Studio, we need to provide a
    // simplified definition of its dependencies to avoid undefined references.
    const dependenciesValues = ramda_1.dissoc(dottedName, Object.fromEntries(dependancies.map((dottedName) => [
        dottedName,
        formatValueForStudio(engine.evaluate(engine.getRule(dottedName))),
    ])));
    const source = `
# Ci-dessous la règle d'origine, écrite en publicodes.

# Publicodes est un langage déclaratif développé par l'Urssaf
# en partenariat avec beta.gouv.fr pour encoder les algorithmes d'intérêt public.

# Vous pouvez modifier les valeurs directement dans l'éditeur pour voir les calculs
# s'actualiser en temps réel
` +
        yaml_1.default
            .stringify({
            [dottedName]: ramda_1.dissoc('nom', rule.rawNode),
        })
            .replace(`${dottedName}:`, `\n${dottedName}:`) +
        '\n\n# Situation :\n' +
        yaml_1.default.stringify(dependenciesValues).split('\n').sort().join('\n');
    // For clarity add a break line before the main rule
    const baseURL = location.hostname === 'localhost' ? '/publicodes' : 'https://publi.codes';
    return (jsx_runtime_1.jsx("div", Object.assign({ style: { textAlign: 'right' } }, { children: jsx_runtime_1.jsxs("a", Object.assign({ className: "ui__ simple small button", target: "_blank", href: `${baseURL}/studio/${encodeRuleName(dottedName)}?code=${encodeURIComponent(source)}` }, { children: [react_easy_emoji_1.default('✍️'), " Voir la r\u00E8gle dans le bac \u00E0 sable Publicodes"] }), void 0) }), void 0));
}
exports.default = RuleSource;
// TODO: This formating function should be in the core code. We need to think
// about the different options of the formatting options and our use cases
// (putting a value in the URL #1169, importing a value in the Studio, showing a value
// on screen)
function formatValueForStudio(node) {
    const base = publicodes_1.formatValue(node)
        .replace(/\s\/\s/g, '/')
        .replace(/(\d)\s(\d)/g, '$1$2')
        .replace(',', '.');
    if (base.match(/^[0-9]/) || base === 'Oui' || base === 'Non') {
        return base.toLowerCase();
    }
    else if (base === '-') {
        return 'non';
    }
    else {
        return `'${base}'`;
    }
}
